module.exports = __webpack_public_path__ + "static/media/category.f0099ec7.svg";